module.exports = __webpack_public_path__ + "media/audio41.9014c840.mp3";